import {Directive, Input} from '@angular/core';
import {DefaultType} from '../../interfaces/dynamic-component-object';

@Directive({
    selector: 'app-dynamic-component-base',
    standalone: false
})
export class DynamicComponentBaseComponent<T = DefaultType | unknown> {
  @Input() data!: T;
}
